import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cphi-pmec',
  templateUrl: './cphi-pmec.component.html',
  styleUrls: ['./cphi-pmec.component.css']
})
export class CPHIPMECComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
